import TicketsPerAgentTable from "../tables/TicketsPerAgentTable";

import { Box } from "@chakra-ui/react";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildTicketVolumeInsights } from "../../../store/reportEnterpriseInsights";


const TicketsPerAgent = ({ reportIndex, data }) => {


  return (
    <Box>
      {data.map((data, index) => {
        const { branchName } = data;
        const title = `${reportIndex || ""}.${index + 1}. ${branchName}`;
        const insights = buildTicketVolumeInsights(data, { scopeLabel: "Agent" });
        return (
          <Box key={index}>
            <h2>{title}</h2>
            <EnterpriseReportSummary
              title="Agent Ticket Productivity Summary"
              kpis={insights.kpis}
              tables={insights.tables}
              notes={insights.notes}
            />
            <TicketsPerAgentTable reportIndex={reportIndex} data={data} branchIndex={index} />
          </Box>
        );
      })}
    </Box>
  );
};

export default TicketsPerAgent;
